// extracted by mini-css-extract-plugin
export default {"modal":"yrtdi5NkS30BFrO5GmNL","content":"SzCBA33TBimxH_oCw_yt"};